import o from "./typeof.js";
import i from "./toPrimitive.js";
function f(t) {
  var r = i(t, "string");
  return o(r) == "symbol" ? r : r + "";
}
export { f as default };